/* global kmAwards */

class Utils {
  ajaxRequest = async (action, ajaxData = {}, ajaxParams = {}, ajaxHeaders = {}) => {
    const {
      ajax: { url, nonce },
    } = kmAwards;

    let formData;

    if (ajaxData instanceof FormData) {
      formData = ajaxData;
    } else {
      formData = new FormData();

      if (ajaxData) {
        Object.entries(ajaxData).forEach(([key, value]) => {
          const isImage = key.includes('image') || key.includes('file');

          if (typeof value === 'object' && value !== null && !isImage) {
            formData.append(key, JSON.stringify(value));
          } else {
            formData.append(key, value);
          }
        });
      }
    }

    const params = {
      method: 'POST',
      headers: {
        'X-WP-Nonce': nonce, // this authenticates users and allows using get_current_user functions in rest api endpoints
        ...ajaxHeaders,
      },
      credentials: 'same-origin',
      ...ajaxParams,
    };

    if (params.method === 'POST') {
      params.body = formData;
    }

    const endpoint = `${url}${action}`;

    try {
      const response = await fetch(endpoint, params);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error in AJAX request:', error);
      throw error;
    }
  };

  scrollTo = (element, offset = 10) => {
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: elementPosition - offset,
      behavior: 'smooth',
    });
  };
}

export default new Utils();
